export const DEFAULT_BUNDLE_DATA = {
  currentStep: 1,
  completedSteps: 0,
  variantId: undefined,
  price: 0,
  quantity: 0,
  title: undefined,
  image: undefined,
  labels: [],
  addedComponentReference: [],
  addedComponentQuantities: [],
  addedComponentPrices: [],
  addedComponentTitles: [],
  addedComponentImages: [],
  addedComponentSteps: [],
  addedComponentOptions: [],
  addedComponentProductIds: [],
  addedComponentMultiple: [],
  addedComponentCustomText: [],
  addedComponentDiscounts: [],
  addedComponentGroupIndex: [],
  addedComponentOnlyForProductIds: []
}

export const CUSTOM_TEXT_REGEX = /[A-Z0-9,.'"&@$():+\-\/—()\s]/g;
